<div class="category-tasks-wrapper">
  <h2 mat-dialog-title>
    Part {{ category.categoryOrder }}: {{ category.displayName }}
  </h2>

  <mat-dialog-content class="category-tasks-container">
    @if (category.tasks && category.tasks.length) {
      <composite-tasks [compositeTasks]="category.tasks"> </composite-tasks>
    }
    @if (!category.tasks || category.tasks.length === 0) {
      <p class="noTasksMessage">No composite tasks.</p>
    }
  </mat-dialog-content>

  <mat-dialog-actions fxLayout="row" fxLayoutAlign="center center">
    <button mat-button color="primary" (click)="close()">Done</button>
  </mat-dialog-actions>
</div>
